/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceTypesService {
  /**
   * @summary Update
   * @description Updates an existing service type.
   */
  updateServiceTypesServiceTypeIdPatch: {
    /**
     * @summary Update
     * @description Updates an existing service type.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateServiceTypesServiceTypeIdPatchBody,
        UpdateServiceTypesServiceTypeIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateServiceTypesServiceTypeIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateServiceTypesServiceTypeIdPatchBody,
          UpdateServiceTypesServiceTypeIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<UpdateServiceTypesServiceTypeIdPatchData, UpdateServiceTypesServiceTypeIdPatchError>
      >
    ): Promise<RequestFnResponse<UpdateServiceTypesServiceTypeIdPatchData, UpdateServiceTypesServiceTypeIdPatchError>>;
    /**
     * @summary Update
     * @description Updates an existing service type.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateServiceTypesServiceTypeIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateServiceTypesServiceTypeIdPatchSchema,
      UpdateServiceTypesServiceTypeIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Updates an existing service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useMutation({
     *     path: {
     *         service_type_id: serviceTypeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_type_id: serviceTypeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateServiceTypesServiceTypeIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateServiceTypesServiceTypeIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceTypesServiceTypeIdPatchSchema,
        UpdateServiceTypesServiceTypeIdPatchData,
        UpdateServiceTypesServiceTypeIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceTypesServiceTypeIdPatchData,
      OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Updates an existing service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useMutation({
     *     path: {
     *         service_type_id: serviceTypeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_type_id: serviceTypeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateServiceTypesServiceTypeIdPatchBody,
        UpdateServiceTypesServiceTypeIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceTypesServiceTypeIdPatchSchema,
        UpdateServiceTypesServiceTypeIdPatchData,
        UpdateServiceTypesServiceTypeIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceTypesServiceTypeIdPatchData,
      OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @description Updates an existing service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateServiceTypesServiceTypeIdPatchTotal = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateServiceTypesServiceTypeIdPatchTotal = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_type_id: serviceTypeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTypesServiceTypeIdPatchBody,
            UpdateServiceTypesServiceTypeIdPatchData,
            UpdateServiceTypesServiceTypeIdPatchParameters,
            OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTypesServiceTypeIdPatchSchema,
            UpdateServiceTypesServiceTypeIdPatchBody,
            UpdateServiceTypesServiceTypeIdPatchData,
            UpdateServiceTypesServiceTypeIdPatchParameters,
            OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @description Updates an existing service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateServiceTypesServiceTypeIdPatchPendingMutationVariables = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateServiceTypesServiceTypeIdPatchMutationData = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_type_id: serviceTypeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateServiceTypesServiceTypeIdPatchData,
        OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
        MutationVariables<UpdateServiceTypesServiceTypeIdPatchBody, UpdateServiceTypesServiceTypeIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTypesServiceTypeIdPatchBody,
            UpdateServiceTypesServiceTypeIdPatchData,
            UpdateServiceTypesServiceTypeIdPatchParameters,
            OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTypesServiceTypeIdPatchSchema,
            UpdateServiceTypesServiceTypeIdPatchBody,
            UpdateServiceTypesServiceTypeIdPatchData,
            UpdateServiceTypesServiceTypeIdPatchParameters,
            OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateServiceTypesServiceTypeIdPatchData,
          OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
          MutationVariables<UpdateServiceTypesServiceTypeIdPatchBody, UpdateServiceTypesServiceTypeIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update
     * @description Updates an existing service type.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTypesServiceTypeIdPatchBody,
            UpdateServiceTypesServiceTypeIdPatchData,
            UpdateServiceTypesServiceTypeIdPatchParameters,
            OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTypesServiceTypeIdPatchSchema,
            UpdateServiceTypesServiceTypeIdPatchBody,
            UpdateServiceTypesServiceTypeIdPatchData,
            UpdateServiceTypesServiceTypeIdPatchParameters,
            OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @description Updates an existing service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_type_id: serviceTypeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceTypesService.updateServiceTypesServiceTypeIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateServiceTypesServiceTypeIdPatchBody,
              UpdateServiceTypesServiceTypeIdPatchData,
              UpdateServiceTypesServiceTypeIdPatchParameters,
              OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceTypesServiceTypeIdPatchSchema,
              UpdateServiceTypesServiceTypeIdPatchBody,
              UpdateServiceTypesServiceTypeIdPatchData,
              UpdateServiceTypesServiceTypeIdPatchParameters,
              OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateServiceTypesServiceTypeIdPatchData,
            UpdateServiceTypesServiceTypeIdPatchError,
            MutationVariables<UpdateServiceTypesServiceTypeIdPatchBody, UpdateServiceTypesServiceTypeIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateServiceTypesServiceTypeIdPatchBody,
              UpdateServiceTypesServiceTypeIdPatchData,
              UpdateServiceTypesServiceTypeIdPatchParameters,
              OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceTypesServiceTypeIdPatchSchema,
              UpdateServiceTypesServiceTypeIdPatchBody,
              UpdateServiceTypesServiceTypeIdPatchData,
              UpdateServiceTypesServiceTypeIdPatchParameters,
              OperationError<UpdateServiceTypesServiceTypeIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateServiceTypesServiceTypeIdPatchData,
          UpdateServiceTypesServiceTypeIdPatchError,
          MutationVariables<UpdateServiceTypesServiceTypeIdPatchBody, UpdateServiceTypesServiceTypeIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateServiceTypesServiceTypeIdPatchSchema;
    types: {
      parameters: UpdateServiceTypesServiceTypeIdPatchParameters;
      data: UpdateServiceTypesServiceTypeIdPatchData;
      error: UpdateServiceTypesServiceTypeIdPatchError;
      body: UpdateServiceTypesServiceTypeIdPatchBody;
    };
  };
}
/**
 * @summary Update
 * @description Updates an existing service type.
 */
export const updateServiceTypesServiceTypeIdPatch = {
  schema: {
    method: 'patch',
    url: '/service_types/{service_type_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateServiceTypesServiceTypeIdPatchSchema;
  [QraftServiceOperationsToken]: ServiceTypesService['updateServiceTypesServiceTypeIdPatch'];
};
export const serviceTypesService = {
  updateServiceTypesServiceTypeIdPatch,
} as const;
type UpdateServiceTypesServiceTypeIdPatchSchema = {
  method: 'patch';
  url: '/service_types/{service_type_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateServiceTypesServiceTypeIdPatchParameters = paths['/service_types/{service_type_id}']['patch']['parameters'];
type UpdateServiceTypesServiceTypeIdPatchData =
  paths['/service_types/{service_type_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateServiceTypesServiceTypeIdPatchError =
  paths['/service_types/{service_type_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateServiceTypesServiceTypeIdPatchBody =
  paths['/service_types/{service_type_id}']['patch']['requestBody']['content']['application/json'];
